// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"9cf7564d","444":"587e4e81","453":"130d29ad","752":"c0e3a12f"}[chunkId] + ".chunk.js";
};